<template>
    <article></article>
</template>

<script>
export default {
    mounted() {},
    created() {},
    props: ["users"],
    data() {
        return {};
    },
    computed: {
        userList() {
            var self = this;
            try {
                if (this.users) {
                    return this.users.filter(function (u) {
                        return !u.is_blocked;
                    });
                }
            } catch (error) {}
            return this.users;
        },
    },
};
</script>
